<h2 mat-dialog-title> {{deletemodel.title | translate}}</h2>
<mat-dialog-content class="mat-typography">
    {{deletemodel.message | translate}}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="warn" (click)="onConfirmClick()" cdkFocusInitial>
        <mat-icon>delete_forever</mat-icon>{{deletemodel.deleteButtonText | translate}}</button>
    <button mat-raised-button mat-dialog-close>{{deletemodel.cancelButtonText | translate}}</button>
</mat-dialog-actions>